module.exports = __webpack_public_path__ + "img/4.84396e45.png";